__turbopack_context__.v({
  "filter": "index-module-scss-module__V53oNq__filter",
  "grid": "index-module-scss-module__V53oNq__grid",
  "jobs": "index-module-scss-module__V53oNq__jobs",
  "location": "index-module-scss-module__V53oNq__location",
  "refine-search": "index-module-scss-module__V53oNq__refine-search",
  "sidebar": "index-module-scss-module__V53oNq__sidebar",
  "title": "index-module-scss-module__V53oNq__title",
});
